import { render, staticRenderFns } from "./VisitingCard.vue?vue&type=template&id=25a8e4b0&scoped=true&"
import script from "./VisitingCard.vue?vue&type=script&lang=js&"
export * from "./VisitingCard.vue?vue&type=script&lang=js&"
import style0 from "./VisitingCard.vue?vue&type=style&index=0&id=25a8e4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8e4b0",
  null
  
)

export default component.exports